module.exports = __webpack_public_path__ + "img/dashboard-income-green.35330538.svg";